module.exports = __webpack_public_path__ + "img/logo.6871024b.png";